import React, { useState } from 'react';

import { ValidationMessage } from '../ValidationMessage';
import { UseFormRegisterReturn } from 'react-hook-form-new';

export type RefType =
    | string
    | ((instance: HTMLInputElement | null) => void)
    | React.RefObject<HTMLInputElement>
    | null
    | undefined;

interface TextInputProps {
    id: string;
    label?: string;
    value?: string;
    type?: 'text' | 'password' | 'email' | 'number' | 'hidden';
    errorMessage?: string;
    defaultValue?: string | number;
    placeholder?: string;
    autocomplete?: 'off' | 'on';
    onChangeHandler?(event: React.ChangeEvent<HTMLInputElement>): void;
    onKeyDownHandler?(event: React.KeyboardEvent<HTMLInputElement>): void;
    reg?: UseFormRegisterReturn;
    disabled?: boolean;
}

export const TextInput = (props: TextInputProps) => {
    const {
        id,
        label,
        type,
        errorMessage,
        defaultValue,
        value,
        onChangeHandler,
        onKeyDownHandler,
        placeholder,
        autocomplete,
        reg,
        disabled,
    } = props;
    const classes = errorMessage ? 'form-text-input with-errors' : 'form-text-input';

    const [inputValue, setInputValue] = useState<string | number | undefined>(defaultValue);

    return (
        <fieldset className="form-group">
            <label htmlFor={`${id}`} className="form-label">
                {label}
            </label>
            <input
                id={`${id}`}
                defaultValue={defaultValue}
                value={value}
                className={classes}
                type={type || 'text'}
                data-at-value={inputValue || ''}
                onKeyDown={onKeyDownHandler}
                placeholder={placeholder}
                autoComplete={autocomplete}
                {...reg}
                onChange={(event) => {
                    setInputValue(event.target.value);

                    if (onChangeHandler) {
                        onChangeHandler(event);
                    }

                    reg?.onChange(event);
                }}
                disabled={disabled}
            />
            {errorMessage && <ValidationMessage>{errorMessage}</ValidationMessage>}
        </fieldset>
    );
};
